<template>
    <AppChartWrapper
        imageName="Total Mentions"
    >
        <h4 slot="title" :class="{'font-weight-bold': $route.name==='comparison'}" class="subheading text-xs-left font-weight-regular section-title--color">
            Total Mentions
        </h4>
        <template slot="chart">
            <LineChart
                    class="pt-4"
                    v-if="summaryDataReady"
                    :chartData="totalMentionChartData"
                    :height="310"
                    :options="totalMentionChartOptions"
                    :width="800"
            />
        </template>
    </AppChartWrapper>
</template>

<script>
	import moment from "moment";
    import LineChart from "../LineChart";
	import {abbrNum, thousandSeperator} from "@/utils";
    import AppChartWrapper from "../AppChartWrapper";
    import _unescape from 'lodash/unescape';
    import _chunk from 'lodash/chunk';

	export default {
		name: "TotalMentionGraph",
		data() {
			return {
				totalMentionChartOptions: {
					responsive: true,
					maintainAspectRatio: false,
					//aspectRatio: 2,
					layout: {
						padding: {
							top: 10,
							right: 10,
							left: 10,
							bottom: 10
						}
					},
					legend: {
						display: this.$route.name === 'comparison'
					},
					tooltips: {
						mode: 'index',
						intersect: false,
                        callbacks:{
							label(item, data){
								let label = _unescape(data.datasets[item.datasetIndex].label);
								return `${label && label }: ${thousandSeperator(item.value)}`
                            }
                        }
					},
					scales: {
						xAxes: [
							{
								gridLines: {
									display: false
								},
								ticks: {
									barThickness: 3
								}
							}
						],
						yAxes: [
							{
								ticks: {
									beginAtZero: true,
									padding: 18,
                                    callback(value, index, values){
										return abbrNum(value,2)
                                    }
								}
							}
						]
					}
				},
			}
		},
		props: {
			totalMentionSuggestedMax: {
				type: Number
            },
			summaryData: {
				type: Array,
				required: true
			},
			summaryDataReady: {
				type: Boolean,
				required: true
			}
		},

		computed: {
			getTotalMention() {
				let fbposts = this.summaryData.fbposts || {};
				let range_count = fbposts.range_count || [];
				return _chunk(range_count, 2);
			},

			totalMentionChartData() {
				const dates = this.summaryData[0].range.filter((i, idx) => idx % 2 === 0);
				const labels = dates.map(date => moment(date).format("YYYY-MM-DD"));
				const datasets = this.summaryData.map(data => ({
                    label: data.label,
                    data: data.range.filter((i, idx) => idx % 2 !== 0),
                    borderColor: data.borderColor,
                    backgroundColor: data.backgroundColor,
                    fill: data.fill
                }));
                return {
					labels,
					datasets
				}
			}
		},

		watch: {
			totalMentionSuggestedMax: {
				handler(val) {
					if (val && val !== 0) {
						let yScale = this.totalMentionChartOptions.scales.yAxes;
						let scale = yScale[0];
						scale.ticks.suggestedMax = val;
						this.$set(this.totalMentionChartOptions.scales.yAxes, 0, scale)
					}
				},
				immediate: true
			}
		},

		components:{
			AppChartWrapper,
			LineChart
        },
	}
</script>

<style scoped>
    .chart-wrapper > div:first-child {
        margin-left: -14px;
    }
</style>
